/* Ask Yuna landing sections: countdown, intent picker, tabs, UGC video. */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  /* Countdown: data-end="YYYY-MM-DDTHH:MM" (store visitor's local time).
     If no end date, or the end date has passed, it counts down to midnight every day. */
  function initTimers(root) {
    root.querySelectorAll('[data-yn-timer]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var raw = el.getAttribute('data-end');
      var end = raw ? new Date(raw) : null;
      var parts = {
        d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'),
        m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]')
      };
      function target() {
        var now = new Date();
        if (end && !isNaN(end) && end > now) return end;
        var t = new Date(now); t.setHours(24, 0, 0, 0); return t;
      }
      function tick() {
        var diff = Math.max(0, target() - new Date());
        var s = Math.floor(diff / 1000);
        parts.d.textContent = pad(Math.floor(s / 86400));
        parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
        parts.m.textContent = pad(Math.floor((s % 3600) / 60));
        parts.s.textContent = pad(s % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* Intent picker: tiles swap the reveal card's content. */
  function initPickers(root) {
    root.querySelectorAll('[data-yn-picker]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '');
      var tiles = wrap.querySelectorAll('[data-yn-tile]');
      var card = wrap.querySelector('[data-yn-reveal]');
      if (!card) return;
      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          tiles.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-pressed', 'false'); });
          tile.classList.add('is-active'); tile.setAttribute('aria-pressed', 'true');
          var tpl = tile.querySelector('template');
          if (tpl) card.innerHTML = tpl.innerHTML;
        });
      });
    });
  }

  /* Tabs */
  function initTabs(root) {
    root.querySelectorAll('[data-yn-tabs]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '');
      var btns = wrap.querySelectorAll('[role="tab"]');
      var panels = wrap.querySelectorAll('[role="tabpanel"]');
      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b, j) {
            var on = i === j;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
            if (panels[j]) panels[j].hidden = !on;
          });
        });
      });
    });
  }

  /* UGC videos: tap to play / pause; only one plays at a time. */
  function initVideos(root) {
    root.querySelectorAll('[data-yn-video]:not([data-ready])').forEach(function (item) {
      item.setAttribute('data-ready', '');
      var video = item.querySelector('video');
      if (!video) return;
      video.removeAttribute('controls');
      item.addEventListener('click', function () {
        if (video.paused) {
          document.querySelectorAll('[data-yn-video] video').forEach(function (v) {
            if (v !== video) { v.pause(); v.closest('[data-yn-video]').classList.remove('is-playing'); }
          });
          video.play(); item.classList.add('is-playing');
        } else {
          video.pause(); item.classList.remove('is-playing');
        }
      });
    });
  }

  /* Buttons left without a link jump to the buy box (product page) or the product spotlight (home). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-yn-buy]');
    if (!a) return;
    var target = document.querySelector('product-info, .product__info-wrapper, [id^="MainProduct"], .yn-spot');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      e.preventDefault();
      window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'collections/all';
    }
  });

  function init(root) {
    root = root || document;
    initTimers(root); initPickers(root); initTabs(root); initVideos(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
/* Ask Yuna: Birthday reveal (birthstone + zodiac) */
(function () {
  /* Birthday reveal: month + day -> birthstone (by month) and western zodiac sign (by date). */
  var SIGNS = [
    ['capricorn', 1, 19, '\u2651'], ['aquarius', 2, 18, '\u2652'], ['pisces', 3, 20, '\u2653'],
    ['aries', 4, 19, '\u2648'], ['taurus', 5, 20, '\u2649'], ['gemini', 6, 20, '\u264A'],
    ['cancer', 7, 22, '\u264B'], ['leo', 8, 22, '\u264C'], ['virgo', 9, 22, '\u264D'],
    ['libra', 10, 22, '\u264E'], ['scorpio', 11, 21, '\u264F'], ['sagittarius', 12, 21, '\u2650']
  ];
  /* SIGNS[i] = sign that ends on (month, lastDay); the next sign starts the day after. */
  function signFor(m, d) {
    var cur = SIGNS[m - 1];
    if (d <= cur[2]) return cur;
    return SIGNS[m % 12];
  }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function initBirth(root) {
    root.querySelectorAll('[data-yn-birth]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '');
      var data; try { data = JSON.parse(wrap.querySelector('[data-yn-birth-data]').textContent); } catch (e) { return; }
      var mSel = wrap.querySelector('[data-yn-birth-month]');
      var dSel = wrap.querySelector('[data-yn-birth-day]');
      var tiles = wrap.querySelectorAll('[data-yn-birth-tile]');
      var empty = wrap.querySelector('[data-yn-birth-empty]');
      var result = wrap.querySelector('[data-yn-birth-result]');
      var $ = function (sel) { return wrap.querySelector(sel); };
      var DAYS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      function syncDays(m) {
        var max = m ? DAYS[m - 1] : 31;
        Array.prototype.forEach.call(dSel.options, function (o) {
          if (!o.value) return;
          var off = +o.value > max; o.disabled = off; o.hidden = off;
        });
        if (+dSel.value > max) dSel.value = '';
      }
      function render() {
        var m = +mSel.value, d = +dSel.value;
        tiles.forEach(function (t) { var on = +t.getAttribute('data-yn-birth-tile') === m; t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        syncDays(m);
        if (!m) { empty.hidden = false; result.hidden = true; empty.querySelector('p').textContent = data.text.prompt; return; }
        var stone = data.months[String(m)] || { stone: '', color: '', image: '', meaning: '' };
        var gem = $('[data-yn-birth-gem]');
        gem.style.setProperty('--gem', stone.color || 'var(--yn-gold-light)');
        gem.innerHTML = stone.image ? '<img src="' + stone.image + '" alt="">' : '';
        $('[data-yn-birth-stone]').innerHTML = '<span class="yn-dot" style="--gem:' + (stone.color || '') + '"></span><span><strong>' + data.text.stonePrefix + ' ' + stone.stone + '</strong>, ' + stone.meaning + '</span>';
        var monthName = data.monthNames[m - 1];
        if (!d) {
          empty.hidden = true; result.hidden = false;
          $('[data-yn-birth-glyph]').textContent = '?';
          $('[data-yn-birth-kicker]').textContent = monthName;
          $('[data-yn-birth-title]').textContent = stone.stone;
          $('[data-yn-birth-teaser]').textContent = data.text.dayPrompt;
          return;
        }
        var sg = signFor(m, d), key = sg[0];
        var teaser = (data.signs[key] && data.signs[key].teaser) || '';
        $('[data-yn-birth-glyph]').textContent = sg[3] + '\uFE0E';
        $('[data-yn-birth-kicker]').textContent = data.text.born + ' ' + monthName + ' ' + d + ' \u00B7 ' + cap(key);
        $('[data-yn-birth-title]').textContent = stone.stone + ' & ' + cap(key);
        $('[data-yn-birth-teaser]').textContent = teaser;
        empty.hidden = true; result.hidden = false;
      }
      mSel.addEventListener('change', render);
      dSel.addEventListener('change', render);
      tiles.forEach(function (t) {
        t.addEventListener('click', function () {
          mSel.value = t.getAttribute('data-yn-birth-tile');
          render();
          if (!dSel.value) { try { dSel.focus({ preventScroll: true }); } catch (e) {} }
        });
      });
      render();
    });
  }

  function run(root) { initBirth(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

/* Ask Yuna: birthday + birthstone pop-up on the product page.
   Buy Now / Add to cart opens a short pop-up asking for each necklace's name and date of birth.
   The birth month selects that necklace's birthstone variant, so the exact items go to checkout and on to CJ.
   Works with or without the theme's colour picker on the page. */
(function () {
  var CFG = {
    optionNames: ['birthstone', 'birth stone', 'colors', 'colours', 'colour', 'color', 'stone'],
    map: null,
    stones: ['Garnet', 'Amethyst', 'Aquamarine', 'Diamond', 'Emerald', 'Alexandrite', 'Ruby', 'Peridot', 'Sapphire', 'Pink Tourmaline', 'Citrine', 'Blue Topaz'],
    meanings: [
      'The stone of devotion and steady fire.', 'The stone of calm and clear intuition.', 'The stone of courage and clear water.',
      'The stone of a strength that doesn\'t crack.', 'The stone of growth and an open heart.', 'The stone of change, and both sides of you.',
      'The stone of passion and protection.', 'The stone of light after a hard season.', 'The stone of truth and quiet wisdom.',
      'The stone of gentle love, starting with yourself.', 'The stone of warmth, luck and abundance.', 'The stone of calm words and a clear path.'
    ],
    colors: ['#7B1C25', '#8E5DB0', '#8FD3E0', '#E6ECF0', '#2E8B57', '#A07AB8', '#C0122C', '#9ACD32', '#1F4FA3', '#E58FB0', '#E9A93B', '#59A8D8'],
    t: {
      titleOne: 'Personalise your necklace',
      titleMany: 'Personalise necklace [n]',
      step: 'Necklace [n] of [total]',
      name: 'Name',
      dob: 'Date of birth',
      stoneIs: 'Birthstone',
      fill: 'Choose a date to see the birthstone.',
      month: 'Month',
      day: 'Day',
      year: 'Year',
      same: 'Same as necklace 1',
      next: 'Next: necklace [n]',
      review: 'Review my necklaces',
      summary: 'Your necklaces',
      summaryNote: 'Each birthstone is set from the birthday you entered. Lady Mei uses the full date for your reading.',
      edit: 'Edit',
      buy: 'Continue to checkout',
      cart: 'Add to cart',
      done: 'Birthdays added',
      unavailable: 'Sorry, this birthstone is not available right now.',
      close: 'Close',
      property: 'Necklace',
      propertyOne: 'Date of birth'
    },
    yearFrom: 1930,
    /* Enchantment picker shown above the bundle boxes. Saved on the order as "Enchantment". */
    enchant: {
      title: 'Enchantment',
      hint: 'Choose the energy Lady Mei casts into this necklace.',
      property: 'Enchantment',
      items: [
        { name: 'Love', tag: 'Attract & deepen', icon: 'heart', text: 'For drawing love in, or deepening the love you already have. Opens the heart and softens what has been guarded.' },
        { name: 'Luck', tag: 'Open doors', icon: 'clover', text: 'For good timing and the right people. Clears the stuck feeling so chances start finding you.' },
        { name: 'Wealth', tag: 'Grow money', icon: 'coin', text: 'For money and career. Lifts the blocks around earning and receiving, so what you work for can stay with you.' },
        { name: 'Protection', tag: 'Shield your energy', icon: 'shield', text: 'For keeping draining people, envy and heavy energy off you. A boundary you wear.' },
      ]
    }
  };
  var ICONS = {
    heart: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
    clover: '<circle cx="9" cy="9" r="3.2"/><circle cx="15" cy="9" r="3.2"/><circle cx="9" cy="15" r="3.2"/><circle cx="15" cy="15" r="3.2"/><path d="M15.5 17.5l3 3.5"/>',
    coin: '<circle cx="12" cy="12" r="8.5"/><path d="M14.6 9.4c-.5-.9-1.5-1.4-2.6-1.4-1.4 0-2.5.8-2.5 2s1.1 1.6 2.5 2 2.5.8 2.5 2-1.1 2-2.5 2c-1.1 0-2.1-.5-2.6-1.4M12 6.5V8M12 16v1.5"/>',
    shield: '<path d="M12 3l7 3v5.5c0 4.6-3 8.4-7 9.5-4-1.1-7-4.9-7-9.5V6z"/><path d="M9 12l2.2 2.2L15.5 10"/>',
    sparkle: '<path d="M11 3l1.8 5.2L18 10l-5.2 1.8L11 17l-1.8-5.2L4 10l5.2-1.8z"/><path d="M18 15l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z"/>'
  };

  var DAYS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  function lc(s) { return String(s || '').toLowerCase().trim(); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fill(s, o) { return s.replace(/\[(\w+)\]/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }
  function find(list, fn) { return Array.prototype.find.call(list, fn); }

  function monthMap(values) {
    var out = {};
    if (CFG.map) Object.keys(CFG.map).forEach(function (k) { values.forEach(function (v) { if (lc(v) === lc(CFG.map[k])) out[+k] = v; }); });
    values.forEach(function (v) {
      var l = lc(v);
      for (var i = 0; i < 12; i++) {
        var full = lc(MONTHS[i]);
        if (!out[i + 1] && new RegExp('(^|[^a-z])(' + full + '|' + full.slice(0, 3) + ')([^a-z]|$)').test(l)) { out[i + 1] = v; return; }
      }
    });
    values.forEach(function (v) {
      if (Object.keys(out).some(function (k) { return out[k] === v; })) return;
      var l = lc(v);
      CFG.stones.forEach(function (s, i) { if (!out[i + 1] && l.indexOf(lc(s)) !== -1) out[i + 1] = v; });
    });
    /* Numbered values like "1" ... "12" or "Color1": the number is the month (1 = January) */
    values.forEach(function (v) {
      var n = lc(v).match(/^(?:colou?rs?|stone|birthstone)?\s*[-_ ]?\s*(\d{1,2})$/);
      if (n && +n[1] >= 1 && +n[1] <= 12 && !out[+n[1]]) out[+n[1]] = v;
    });
    return out;
  }
  function groupsOf(vs) {
    return Array.prototype.map.call(vs.querySelectorAll('.product-form__input'), function (g) {
      var sel = g.querySelector('select'), radios = g.querySelectorAll('input[type="radio"]');
      return {
        el: g, select: sel,
        name: sel ? (sel.name.match(/options\[(.*)\]/) || [, ''])[1] : (radios[0] ? radios[0].name : ''),
        values: sel ? Array.prototype.map.call(sel.options, function (o) { return o.value; }) : Array.prototype.map.call(radios, function (r) { return r.value; })
      };
    });
  }
  function pick(groups) {
    for (var i = 0; i < CFG.optionNames.length; i++) { var g = find(groups, function (x) { return lc(x.name) === CFG.optionNames[i]; }); if (g) return g; }
    for (var j = 0; j < CFG.optionNames.length; j++) { var h = find(groups, function (x) { return lc(x.name).indexOf(CFG.optionNames[j]) !== -1; }); if (h) return h; }
    return null;
  }
  var PEAR = 'M20 9C25 16 32 24 32 35.5A12 12 0 0 1 8 35.5C8 24 15 16 20 9Z';
  function gem(m, cls) {
    if (CFG.noStone) return '';
    return '<span class="yn-bd-gem' + (cls ? ' ' + cls : '') + '" style="--gem:' + CFG.colors[m - 1] + '"><svg viewBox="0 0 40 50" aria-hidden="true" focusable="false">' +
      '<circle cx="20" cy="5" r="2.6" fill="none" stroke="#C9A24B" stroke-width="1.5"/>' +
      '<path d="' + PEAR + '" style="fill:var(--gem)"/>' +
      '<path d="M20 12L27 33.5L20 45.5L13 33.5Z" fill="#fff" opacity=".2"/>' +
      '<path d="M20 12L13 33.5L8.6 37Z" fill="#000" opacity=".14"/>' +
      '<path d="M20 12L27 33.5L31.4 37Z" fill="#fff" opacity=".28"/>' +
      '<path d="M13 33.5L20 45.5L10 42Z" fill="#000" opacity=".22"/>' +
      '<path d="M27 33.5L20 45.5L30 42Z" fill="#000" opacity=".1"/>' +
      '<path d="M15.5 23L18.5 16.5" stroke="#fff" stroke-width="1.6" stroke-linecap="round" opacity=".85"/>' +
      '<path d="' + PEAR + '" fill="none" stroke="#C9A24B" stroke-width="2.2" stroke-linejoin="round"/>' +
      '<path d="M8.4 36.5l-1.6 1.4M31.6 36.5l1.6 1.4M20 47.4v2" stroke="#C9A24B" stroke-width="2" stroke-linecap="round"/>' +
      '</svg></span>';
  }

  /* Product data straight from Shopify, used when the page has no colour picker */
  function productJson(cb) {
    var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!h || !window.fetch) return cb(null);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(cb, function () { cb(null); });
  }
  function virtualGroup(p) {
    if (!p || !p.options || !p.variants || p.variants.length < 2) return null;
    var groups = p.options.map(function (o, i) { return { name: o.name, values: o.values, index: i }; });
    var g = pick(groups);
    if (!g) return null;
    g.virtual = true; g.product = p;
    return g;
  }
  function setup(info) {
    if (info.hasAttribute('data-yn-bd')) return;
    info.setAttribute('data-yn-bd', '');
    var o = window.YN_BD_CONFIG; if (o && !CFG.ov) { CFG.ov = 1; if (o.t) for (var k in o.t) CFG.t[k] = o.t[k]; if ('enchant' in o) CFG.enchant = o.enchant; CFG.noStone = !!o.noStone; } if (CFG.noStone) return init(info, null, null);
    var vs = info.querySelector('variant-selects');
    var G = vs ? pick(groupsOf(vs)) : null;
    if (G) return init(info, vs, G);
    /* No colour picker on the page: read the colours from Shopify and set the variant directly */
    productJson(function (p) { init(info, null, virtualGroup(p)); });
  }
  function init(info, vs, G) {
    var formEl = info.querySelector('product-form form') || document.querySelector('product-form.main-product-form form');
    var qb = info.querySelector('quantity-breaks') || document.querySelector('quantity-breaks');
    var anchor = (G && !G.virtual && vs) || qb || info.querySelector('product-form');
    if (!anchor || !formEl) return;
    var idInput = formEl.querySelector('[name="id"]');
    /* form.id is shadowed by the theme's <input name="id">, so read the attribute */
    var formId = formEl.getAttribute('id') || '';

    var map = {};
    if (G) map = monthMap(G.values);
    else {
      for (var mm = 1; mm <= 12; mm++) map[mm] = String(mm);
      if (window.console) console.warn('[Ask Yuna] No birthstone/colour option found on this product. Birthdays are saved on the order, but no colour variant is being selected.');
    }
    var charms = [];
    for (var c = 0; c < 6; c++) charms.push({ name: '', m: 0, d: 0, y: 0, e: '' });
    function dob(ch) { return ch.d + ' ' + MONTHS[ch.m - 1] + ' ' + ch.y; }
    function maxDay(ch) { var n = DAYS[ch.m - 1]; if (ch.m === 2 && ch.y && !((ch.y % 4 === 0 && ch.y % 100 !== 0) || ch.y % 400 === 0)) n = 28; return n; }
    var bypass = false, applying = false;

    if (G && G.el) G.el.classList.add('yn-dob-hide');
    var chip = document.createElement('div');
    chip.className = 'yn-bd-chip';
    chip.hidden = true;
    anchor.parentNode.insertBefore(chip, anchor);
    var props = document.createElement('div');
    props.hidden = true;
    anchor.parentNode.insertBefore(props, anchor);


    function qty() { var i = qb && qb.querySelector('input[name="quantity"]:checked'); return i ? (parseInt(i.value, 10) || 1) : 1; }
    function offerLabel() { var i = qb && qb.querySelector('input[name="quantity"]:checked'); return i ? qb.querySelector('.quantity-break[data-input="' + i.getAttribute('data-input') + '"]') : null; }
var E = null; /* enchantment choice turned off */    function done1(ch) { return ch.m && ch.d && ch.y && map[ch.m] && (!E || ch.e); }
    function enchHtml(ch) {
      var h = '<p class="yn-bd__label">' + esc(E.title) + '</p><div class="yn-ench__grid yn-bd__ench-grid" role="radiogroup" aria-label="' + esc(E.title) + '">';
      E.items.forEach(function (it) {
        h += '<button type="button" class="yn-ench__opt' + (ch.e === it.name ? ' is-on' : '') + '" role="radio" aria-checked="' + (ch.e === it.name) + '" data-ench="' + esc(it.name) + '">' +
          '<span class="yn-ench__ico"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (ICONS[it.icon] || ICONS.sparkle) + '</svg></span>' +
          '<span class="yn-ench__name">' + esc(it.name) + '</span><span class="yn-ench__tag">' + esc(it.tag) + '</span></button>';
      });
      var cur = find(E.items, function (x) { return x.name === ch.e; });
      return h + '</div><div class="yn-ench__desc" data-ench-desc>' + (cur ? '<strong>' + esc(cur.name) + '.</strong> ' + esc(cur.text) : esc(E.hint)) + '</div>';
    }
    function detail(ch) { return (ch.name ? ch.name + ' \u00B7 ' : '') + dob(ch) + (CFG.noStone ? '' : ' \u00B7 ' + CFG.stones[ch.m - 1]) + (ch.e ? ' \u00B7 ' + E.property + ': ' + ch.e : ''); }
    function complete() { for (var i = 0; i < qty(); i++) if (!done1(charms[i])) return false; return true; }
    function optSelect(item) { if (!G) return null; return find(item.querySelectorAll('select'), function (x) { return x.name === 'options[' + G.name + ']'; }); }

    function hideBundle() {
      if (!qb) return;
      qb.querySelectorAll('.quantity-break__variants').forEach(function (v) { v.classList.add('yn-dob-hide'); });
    }
    function variantById(id) { return find(G.product.variants, function (v) { return String(v.id) === String(id); }); }
    function current() {
      if (!G) return null;
      if (G.virtual) { var cv = idInput && variantById(idInput.value); return cv ? cv.options[G.index] : null; }
      return G.select ? G.select.value : (find(G.el.querySelectorAll('input[type="radio"]:checked'), function () { return true; }) || {}).value; }
    function applyMain() {
      var v = G && charms[0].m ? map[charms[0].m] : null;
      if (!v || current() === v) return;
      if (G.virtual) {
        if (!idInput) return;
        var base = variantById(idInput.value) || G.product.variants[0];
        var want = base.options.slice(); want[G.index] = v;
        var nv = find(G.product.variants, function (x) { return x.options.join('|') === want.join('|'); }) ||
                 find(G.product.variants, function (x) { return x.options[G.index] === v; });
        if (!nv) return;
        idInput.value = nv.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var el;
      if (G.select) { G.select.value = v; el = G.select; }
      else { el = find(G.el.querySelectorAll('input[type="radio"]'), function (x) { return x.value === v; }); if (!el) return; el.checked = true; }
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function applyBundle() {
      var n = qty(), label = offerLabel();
      if (!G || n < 2 || !label) return;
      var items = label.querySelectorAll('.quantity-break__selector-item');
      applying = true;
      for (var i = 0; i < n && i < items.length; i++) {
        var v = charms[i].m ? map[charms[i].m] : null, s = optSelect(items[i]);
        if (v && s && s.value !== v) { s.value = v; s.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      applying = false;
    }
    function inSync() {
      if (!G) return true;
      if (charms[0].m && current() !== map[charms[0].m]) return false;
      var n = qty(), label = offerLabel();
      if (n < 2 || !label) return true;
      var items = label.querySelectorAll('.quantity-break__selector-item');
      for (var i = 0; i < n && i < items.length; i++) { var s = optSelect(items[i]); if (s && charms[i].m && s.value !== map[charms[i].m]) return false; }
      return true;
    }
    function applyAll() { applyMain(); applyBundle(); writeProps(); }
    function settle(cb) {
      var tries = 0;
      (function loop() { setTimeout(function () { applyBundle(); if (inSync() || ++tries > 10) cb(); else loop(); }, tries === 0 ? 350 : 200); })();
    }

    function writeProps() {
      props.innerHTML = '';
      var n = qty();
      for (var i = 0; i < n; i++) {
        var ch = charms[i];
        if (!done1(ch)) continue;
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + (n > 1 ? CFG.t.property + ' ' + (i + 1) : CFG.t.propertyOne) + ']';
        inp.value = detail(ch);
        if (formId) inp.setAttribute('form', formId);
        props.appendChild(inp);
      }
      renderChip();
    }
    function renderChip() {
      if (!complete()) { chip.hidden = true; return; }
      var n = qty(), h = '<div class="yn-bd-chip__head"><span>' + esc(CFG.t.done) + '</span><button type="button" data-edit>' + esc(CFG.t.edit) + '</button></div><ul>';
      for (var i = 0; i < n; i++) {
        var ch = charms[i];
        h += '<li>' + gem(ch.m) + '<span>' + (n > 1 ? '<b>' + (i + 1) + '.</b> ' : '') + esc(detail(ch)) + '</span></li>';
      }
      chip.innerHTML = h + '</ul>';
      chip.hidden = false;
    }
    chip.addEventListener('click', function (e) { if (e.target.closest('[data-edit]')) open(null, 'review'); });

    var modal = document.createElement('div');
    modal.className = 'yn-bd';
    modal.hidden = true;
    modal.innerHTML = '<div class="yn-bd__backdrop" data-close></div><div class="yn-bd__sheet" role="dialog" aria-modal="true" aria-label="Birthstones"><button type="button" class="yn-bd__x" data-close aria-label="' + esc(CFG.t.close) + '">×</button><div class="yn-bd__body" data-body></div></div>';
    document.body.appendChild(modal);
    var body = modal.querySelector('[data-body]');
    var state = { i: 0, view: 'form', action: null };

    function open(action, view) {
      state.action = action || state.action || { type: 'cart' };
      if ((view === 'review' || complete()) && qty() > 1) state.view = 'review';
      else {
        state.i = 0;
        for (var k = 0; k < qty(); k++) if (!done1(charms[k])) { state.i = k; break; }
        state.view = 'form';
      }
      draw();
      modal.hidden = false;
      document.documentElement.classList.add('yn-bd-lock');
      setTimeout(function () { modal.classList.add('is-open'); }, 10);
    }
    function close() {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('yn-bd-lock');
      setTimeout(function () { modal.hidden = true; }, 200);
    }
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    function dayOptions(ch) {
      var o = '<option value="">' + esc(CFG.t.day) + '</option>';
      for (var d = 1; d <= (ch.m ? maxDay(ch) : 31); d++) o += '<option value="' + d + '"' + (ch.d === d ? ' selected' : '') + '>' + d + '</option>';
      return o;
    }
    function revealHtml(ch) {
      if (CFG.noStone || !ch.m) return '<p class="yn-bd__hint">' + esc(CFG.t.fill) + '</p>';
      if (!map[ch.m]) return '<p class="yn-bd__err">' + esc(CFG.t.unavailable) + '</p>';
      return '<div class="yn-bd__reveal">' + gem(ch.m, 'yn-bd-gem--xl') + '<div><p class="yn-bd__kicker">' + esc(CFG.t.stoneIs) + '</p><p class="yn-bd__big">' + esc(CFG.stones[ch.m - 1]) + '</p><p class="yn-bd__line">' + esc(CFG.meanings[ch.m - 1]) + '</p>' + '</div></div>';
    }
    function goLabel() {
      var n = qty();
      if (n === 1) return ctaLabel();
      return state.i + 1 < n ? fill(CFG.t.next, { n: state.i + 2 }) : CFG.t.review;
    }
    function ctaLabel() { return state.action && state.action.type === 'buy' ? CFG.t.buy : CFG.t.cart; }
    function draw() {
      var n = qty(), ch = charms[state.i], h = '';
      if (state.view === 'review') {
        h += '<h3 class="yn-bd__title">' + esc(CFG.t.summary) + '</h3><p class="yn-bd__note">' + esc(CFG.t.summaryNote) + '</p><ul class="yn-bd__list">';
        for (var k = 0; k < n; k++) {
          var c2 = charms[k];
          h += '<li>' + gem(c2.m, 'yn-bd-gem--lg') + '<div><b>' + esc(CFG.t.property) + ' ' + (k + 1) + (c2.name ? ' · ' + esc(c2.name) : '') + '</b><span>' + dob(c2) + (CFG.noStone ? '' : ' \u00B7 ' + esc(CFG.stones[c2.m - 1])) + (c2.e ? ' \u00B7 ' + esc(c2.e) : '') + '</span></div><button type="button" class="yn-bd__link" data-goto="' + k + '">' + esc(CFG.t.edit) + '</button></li>';
        }
        h += '</ul><button type="button" class="yn-bd__cta" data-finish>' + esc(ctaLabel()) + '</button>';
        body.innerHTML = h;
        return;
      }
      var dots = '';
      for (var d = 0; d < n; d++) dots += '<i class="' + (d < state.i ? 'is-done' : d === state.i ? 'is-on' : '') + '"></i>';
      h += '<div class="yn-bd__step">' + (n > 1 ? esc(fill(CFG.t.step, { n: state.i + 1, total: n })) + '<span class="yn-bd__dots">' + dots + '</span>' : '') + '</div>';
      h += '<h3 class="yn-bd__title">' + esc(n > 1 ? fill(CFG.t.titleMany, { n: state.i + 1 }) : CFG.t.titleOne) + '</h3>';
      if (state.i > 0 && done1(charms[0]) && !ch.m && !ch.d && !ch.y) h += '<button type="button" class="yn-bd__link yn-bd__same" data-same>' + esc(CFG.t.same) + '</button>';
      h += '<label class="yn-bd__label" for="yn-bd-name">' + esc(CFG.t.name) + '</label><input id="yn-bd-name" class="yn-bd__name" type="text" maxlength="40" placeholder="' + esc(CFG.t.name) + '" value="' + esc(ch.name) + '" data-name autocomplete="off">';
      h += '<p class="yn-bd__label">' + esc(CFG.t.dob) + '</p><div class="yn-bd__dob">';
      h += '<select class="yn-bd__sel" data-f="d" aria-label="' + esc(CFG.t.day) + '">' + dayOptions(ch) + '</select>';
      h += '<select class="yn-bd__sel" data-f="m" aria-label="' + esc(CFG.t.month) + '"><option value="">' + esc(CFG.t.month) + '</option>';
      for (var m = 1; m <= 12; m++) h += '<option value="' + m + '"' + (ch.m === m ? ' selected' : '') + (map[m] ? '' : ' disabled') + '>' + MONTHS[m - 1] + '</option>';
      h += '</select><select class="yn-bd__sel" data-f="y" aria-label="' + esc(CFG.t.year) + '"><option value="">' + esc(CFG.t.year) + '</option>';
      for (var yy = new Date().getFullYear(); yy >= CFG.yearFrom; yy--) h += '<option value="' + yy + '"' + (ch.y === yy ? ' selected' : '') + '>' + yy + '</option>';
      h += '</select></div><div data-out>' + revealHtml(ch) + '</div>';
      if (E) h += enchHtml(ch);
      h += '<button type="button" class="yn-bd__cta" data-go' + (done1(ch) ? '' : ' disabled') + '>' + esc(goLabel()) + '</button>';
      body.innerHTML = h;
    }

    body.addEventListener('input', function (e) { if (e.target.matches('[data-name]')) { charms[state.i].name = e.target.value.trim(); writeProps(); } });
    body.addEventListener('change', function (e) {
      var s = e.target.closest('select[data-f]');
      if (!s) return;
      var ch = charms[state.i], f = s.getAttribute('data-f');
      ch[f] = +s.value || 0;
      if (f !== 'd') {
        if (ch.d && ch.m && ch.d > maxDay(ch)) ch.d = 0;
        var ds = body.querySelector('select[data-f="d"]'); if (ds) ds.innerHTML = dayOptions(ch);
      }
      if (f === 'm') { body.querySelector('[data-out]').innerHTML = revealHtml(ch); applyAll(); } else writeProps();
      var g = body.querySelector('[data-go]'); if (g) g.disabled = !done1(ch);
    });
    body.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      var ch = charms[state.i];
      if (t.hasAttribute('data-ench')) {
        ch.e = t.getAttribute('data-ench');
        body.querySelectorAll('[data-ench]').forEach(function (x) { var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
        var it = find(E.items, function (x) { return x.name === ch.e; });
        body.querySelector('[data-ench-desc]').innerHTML = '<strong>' + esc(it.name) + '.</strong> ' + esc(it.text);
        writeProps();
        var gb = body.querySelector('[data-go]'); if (gb) gb.disabled = !done1(ch);
        return;
      }
      if (t.hasAttribute('data-same')) { ch.m = charms[0].m; ch.d = charms[0].d; ch.y = charms[0].y; draw(); applyAll(); }
      else if (t.hasAttribute('data-go')) {
        if (!done1(ch)) return;
        if (qty() === 1) finish(t);
        else if (state.i + 1 < qty()) { state.i++; state.view = 'form'; draw(); }
        else { state.view = 'review'; draw(); }
      }
      else if (t.hasAttribute('data-goto')) { state.i = +t.getAttribute('data-goto'); state.view = 'form'; draw(); }
      else if (t.hasAttribute('data-finish')) finish(t);
    });

    function go() {
      var a = state.action || { type: 'cart' };
      bypass = true;
      setTimeout(function () { bypass = false; }, 3000);
      if (a.type === 'buy' && a.el) a.el.click();
      else if (formEl) { if (formEl.requestSubmit) formEl.requestSubmit(a.submitter || undefined); else formEl.submit(); }
    }
    function finish(btn) {
      if (!complete()) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      applyAll();
      settle(function () { writeProps(); close(); go(); btn.disabled = false; btn.classList.remove('is-loading'); });
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[id^="SectionAtcBtn-"]');
      if (!b || bypass) return;
      e.preventDefault(); e.stopImmediatePropagation();
      state.action = { type: 'buy', el: b };
      if (complete()) { applyAll(); settle(go); } else open(state.action);
    }, true);
    document.addEventListener('submit', function (e) {
      if (!formEl || e.target !== formEl || bypass) return;
      if (complete()) { writeProps(); return; }
      e.preventDefault(); e.stopImmediatePropagation();
      open({ type: 'cart', submitter: e.submitter && e.submitter.form === formEl ? e.submitter : null });
    }, true);

    if (qb) {
      qb.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'quantity') setTimeout(function () { hideBundle(); applyBundle(); writeProps(); }, 0);
      });
      var tm = null;
      new MutationObserver(function (muts) {
        if (applying) return;
        if (!muts.some(function (m) { return m.target.tagName === 'SELECT' || (m.target.closest && m.target.closest('select')); })) return;
        clearTimeout(tm);
        tm = setTimeout(function () { hideBundle(); applyBundle(); }, 60);
      }).observe(qb, { childList: true, subtree: true });
    }
    hideBundle();
    writeProps();
  }

  function run() { document.querySelectorAll('[id^="ProductInfo-"]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
